import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditOrDeleteButtons',
  props: {
    item: {},
    deleteAuthority: { type: Boolean },
    openUnexpectedModal: { type: Function },
    openDeleteConfirmModal: { type: Function }
  },
  setup(__props: any) {

const props = __props

const displayEditIcon = computed(() => (division: string) => {
  return division == 'unexpected_events'
})

const displayDeleteIcon = computed(() => (item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) => {
  return !item.ignore
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex", displayEditIcon.value(__props.item.division_name) ? 'justify-space-between' : 'justify-end']),
    style: {"width":"75%"}
  }, [
    (displayEditIcon.value(__props.item.division_name))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "h-100 d-flex align-center edit-or-alert-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (props.openUnexpectedModal(__props.item)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, " edit_note ", -1)
        ]))]))
      : _createCommentVNode("", true),
    (displayDeleteIcon.value(__props.item) && props.deleteAuthority)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "h-100 d-flex align-center edit-or-alert-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (props.openDeleteConfirmModal(__props.item)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", {
            class: "material-symbols-outlined",
            style: {"color":"red"}
          }, " delete ", -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})